<sh-page id="login-page-1" [theme]="theme">
    <sh-splash-screen id="login-splash-screen-2" modal [label]="''" [version]="''">
        <img src="assets/images/Axis_Image.png" [attr.alt]="'login.splash.altText' | transloco" width="150" />
        <div style="width: 100%; display: flex; flex-direction: column; align-items: center;">
            <!-- <sh-text id="login-text-3" size="title-1" style="width: auto;">{{title}}</sh-text> -->
            <sh-text id="login-text-4" size="title-1" style="width: auto;">{{ 'login.version' | transloco: { version: version } }}</sh-text>
        </div>

        <sh-button id="login-button-log-in" style="margin-top: 32px;" [attr.label]="loginButtonLabel" (click)="onLoginClick()"></sh-button>
        <sh-text id="login-text-6" slot="info" size="body-2" color="secondary">{{ 'login.copyright' | transloco }}</sh-text>
    </sh-splash-screen>
</sh-page>